
window.onload = function () {
    var ACTIVE_CLASS = 'is-active';

    function generateTableHead(table, data) {
        let thead = table.createTHead();
        let row = thead.insertRow();

        for (let key in data) {
            let th = document.createElement("th");
            let text = document.createTextNode(data[key]);
            th.appendChild(text);
            row.appendChild(th);
        }
    }

    function generateTable(table, data) {
        for (let element of data) {
            let row = table.insertRow();
            for (let key in element) {
                let cell = row.insertCell();
                let text = document.createTextNode(element[key]);
                cell.appendChild(text);
            }
        }
    }

    function showLoader(section) {    
        section.querySelector('.Byggebasen__loading').classList.add(ACTIVE_CLASS);
    }

    function hideLoader(section) {
        section.querySelector('.Byggebasen__loading').classList.remove(ACTIVE_CLASS);
    }

    function findResults(currentItemId, currentLanguage, keyword, section) {
        var request = new XMLHttpRequest();
  
        request.open('GET', '/api/sitecore/byggebasen/search?keyword=' + keyword + '&language=' + currentLanguage + '&currentItemId=' + currentItemId);

        request.onreadystatechange = function () {
            var DONE = 4; // readyState 4 means the request is done.
            var OK = 200; // status 200 is a successful return.

            if (request.readyState === DONE) {
                if (request.status === OK) {
                    var response = JSON.parse(request.response);
                    var data = response.result

                    if (data.Data.length > 0) {
                        hideLoader(section);
                        setDatatoTable(data);
                    } else {
                        showNotFound(section);
                        hideLoader(section);
                    }
                }
            }
        };

        request.send();
    }

    function showNotFound(section) {
        section.querySelector('.Byggebasen__notfound').classList.add(ACTIVE_CLASS);
        let table = document.querySelector("table");
        table.innerHTML = '';
    } 

    function hideNotFound(section) {
        section.querySelector('.Byggebasen__notfound').classList.remove(ACTIVE_CLASS);
        let table = document.querySelector("table");
        table.innerHTML = '';
    } 


    function setDatatoTable(response) {
        let table = document.querySelector("table");

        if (table && response.Data) {
            if (response.ColumnHeader) {
                generateTableHead(table, response.ColumnHeader);
            }

            var chunkArray = sliceIntoChunks(response.Data, 5);

            for (let j = 0; j < chunkArray.length; j++) {
                if (j == 0) {
                    generateTable(table, chunkArray[j]);
                } else {
                    setTimeout(function () {
                        generateTable(table, chunkArray[j]);
                    }, 1000);

                }
            }  
        }
    }

    function sliceIntoChunks(arr, chunkSize) {
        const res = [];
        for (let i = 0; i < arr.length; i += chunkSize) {
            const chunk = arr.slice(i, i + chunkSize);
            res.push(chunk);
        }
        return res;
    }


    function init() {
        const byggebasen = document.querySelectorAll('.Byggebasen');

        if (byggebasen.length > 0) {
            byggebasen.forEach(function (section) {
                var currentItemId = section.querySelector('.Byggebasen__currentItemId').value;
                var currentLanguage = section.querySelector('.Byggebasen__currentLanguage').value;

                section.querySelector('.Byggebasen__form button').addEventListener('click', function (event) {
                    event.preventDefault();
                    var keyword = section.querySelector('.Byggebasen__value').value;
                    hideNotFound(section)

                    if (keyword !== '') {
                        showLoader(section);
                        findResults(currentItemId, currentLanguage, keyword, section);
                    } 

                })
            });
        }
    }

    init();
};